export default __webpack_public_path__ + "static/media/pagination-arrow-left.b90a8593.svg";